module.exports = __webpack_public_path__ + "static/media/formas-banner-1.a3f1aed9.png";